module.exports = __webpack_public_path__ + "img/onboarding-icon-wallet.d09b9631.svg";